<div class="rounded-3xl border border-neutral-3 bg-neutral-1 shadow-sm p-5 sm:p-7 flex flex-col gap-6">
  <!-- HEADER -->
  <div class="flex items-center justify-between border-b border-neutral-3 pb-4">
    <div class="flex items-center gap-3">
      <div
        class="flex size-9 items-center justify-center rounded-xl bg-indigo-2 text-indigo-11 border border-indigo-3"
      >
        <mat-icon class="size-5 !text-lg">handshake</mat-icon>
      </div>
      <div>
        <h3 class="text-base sm:text-lg font-bold text-neutral-12 m-0">
          {{ hasFinalOffer() ? 'Engagement commercial et offre finale' : 'Mon engagement commercial' }}
        </h3>
        <p class="text-xs text-neutral-10 m-0">
          {{
            hasFinalOffer()
              ? 'Avis de valeur du bien, honoraires définitifs et stratégie de commercialisation'
              : 'Conditions transmises au propriétaire lors de la candidature'
          }}
        </p>
      </div>
    </div>

    @if (hasFinalOffer()) {
      <span
        class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-indigo-2 text-indigo-11 border border-indigo-4"
      >
        <mat-icon class="!text-xs size-3.5">verified</mat-icon>
        <span>
          @if (finalOfferSubmittedAt(); as date) {
            Offre finale transmise le {{ date | luxonDate: 'd MMMM yyyy' }}
          } @else {
            Offre finale transmise
          }
        </span>
      </span>
    }
  </div>

  <!-- 1. AVIS DE VALEUR & ESTIMATION DU BIEN (POST-VISITE) -->
  @if (hasValuationPrices()) {
    <div class="rounded-2xl border border-indigo-4/70 bg-indigo-2/30 p-4 sm:p-5 flex flex-col gap-4">
      <div class="flex items-center justify-between flex-wrap gap-2">
        <div class="flex items-center gap-2">
          <mat-icon class="!text-base size-4 text-indigo-11">trending_up</mat-icon>
          <span class="text-xs font-bold text-indigo-12 uppercase tracking-wide">
            Avis de valeur du bien (estimation post-visite)
          </span>
        </div>
        <span class="text-[11px] text-neutral-10">
          Fourchettes de commercialisation établies par l'agent
        </span>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <!-- Prix attractif -->
        @if (attractivePriceEuros(); as attract) {
          <div class="p-3.5 rounded-xl bg-white dark:bg-neutral-2 border border-neutral-3 flex flex-col">
            <span class="text-[11px] font-semibold text-neutral-10 block">Prix attractif</span>
            <span class="text-lg sm:text-xl font-bold text-neutral-12 mt-1 block">
              {{ attract | number: '1.0-0' : 'fr-FR' }} €
            </span>
            <span class="text-[10px] text-neutral-9 mt-1 block">Vente rapide sous 30 jours</span>
          </div>
        }

        <!-- Prix conseillé (valeur de référence) -->
        @if (recommendedPriceEuros(); as rec) {
          <div
            class="p-3.5 rounded-xl bg-indigo-1 dark:bg-neutral-2 border-2 border-indigo-5 flex flex-col shadow-2xs"
          >
            <div class="flex items-center justify-between gap-1">
              <span class="text-[11px] font-bold text-indigo-11">Prix conseillé</span>
              <span
                class="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.2 rounded bg-indigo-3 text-indigo-11"
              >
                Référence
              </span>
            </div>
            <span class="text-xl sm:text-2xl font-extrabold text-indigo-12 mt-1 block">
              {{ rec | number: '1.0-0' : 'fr-FR' }} €
            </span>
            <span class="text-[10px] text-indigo-10 mt-1 block font-medium">
              @if (priceDifferencePercent(); as diff) {
                {{ diff > 0 ? '+' : '' }}{{ diff }} % par rapport au prix souhaité
              } @else {
                Valeur de marché recommandée
              }
            </span>
          </div>
        }

        <!-- Prix coup de cœur -->
        @if (heartStrokePriceEuros(); as stroke) {
          <div class="p-3.5 rounded-xl bg-white dark:bg-neutral-2 border border-neutral-3 flex flex-col">
            <span class="text-[11px] font-semibold text-neutral-10 block">Prix coup de cœur</span>
            <span class="text-lg sm:text-xl font-bold text-neutral-12 mt-1 block">
              {{ stroke | number: '1.0-0' : 'fr-FR' }} €
            </span>
            <span class="text-[10px] text-neutral-9 mt-1 block">Fourchette haute de commercialisation</span>
          </div>
        }
      </div>

      <!-- CONFRONTATION AU MARCHÉ DVF DU SECTEUR -->
      @if (dvfData(); as dvf) {
        @if (dvf.medianPriceM2) {
          <div class="pt-4 border-t border-indigo-4/60 flex flex-col gap-3.5">
            <div class="flex items-center justify-between flex-wrap gap-2">
              <div class="flex items-center gap-2">
                <mat-icon class="size-4 !text-base text-indigo-11">balance</mat-icon>
                <span class="text-xs font-bold text-neutral-12 uppercase tracking-wide">
                  Confrontation au marché réel (DVF État)
                </span>
              </div>

              @if (dvfMedianDiffPercent(); as diffDvf) {
                <span
                  class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-bold border"
                  [class]="
                    diffDvf > 10
                      ? 'bg-amber-2 text-amber-11 border-amber-5'
                      : diffDvf < -10
                        ? 'bg-sky-2 text-sky-11 border-sky-5'
                        : 'bg-jade-2 text-jade-11 border-jade-5'
                  "
                >
                  <mat-icon class="size-3.5 !text-xs">{{
                    diffDvf > 0 ? 'north_east' : diffDvf < 0 ? 'south_east' : 'check'
                  }}</mat-icon>
                  <span>
                    {{ diffDvf > 0 ? '+' : '' }}{{ diffDvf }} % par rapport à la médiane DVF du quartier
                  </span>
                </span>
              }
            </div>

            <!-- Grille des 3 repères comparatifs au m² -->
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
              <!-- Repère 1 : Prix conseillé agent au m² -->
              @if (agentPricePerM2(); as agentM2) {
                <div class="p-3 rounded-xl bg-white border border-neutral-3 flex flex-col">
                  <span class="text-[11px] font-semibold text-neutral-10">Prix conseillé agent</span>
                  <div class="flex items-baseline gap-1 mt-0.5">
                    <span class="text-base font-black text-indigo-12"
                      >{{ agentM2 | number: '1.0-0' : 'fr-FR' }} €</span
                    >
                    <span class="text-[11px] text-neutral-9 font-medium">/ m²</span>
                  </div>
                  @if (surfaceHabitable(); as surf) {
                    <span class="text-[10px] text-neutral-9 mt-0.5">Pour {{ surf }} m² habitables</span>
                  }
                </div>
              }

              <!-- Repère 2 : Médiane DVF quartier -->
              <div class="p-3 rounded-xl bg-white border border-neutral-3 flex flex-col">
                <span class="text-[11px] font-semibold text-neutral-10">Médiane DVF quartier</span>
                <div class="flex items-baseline gap-1 mt-0.5">
                  <span class="text-base font-black text-neutral-12"
                    >{{ dvf.medianPriceM2 | number: '1.0-0' : 'fr-FR' }} €</span
                  >
                  <span class="text-[11px] text-neutral-9 font-medium">/ m²</span>
                </div>
                <span class="text-[10px] text-neutral-9 mt-0.5"
                  >{{ dvf.salesCount }} ventes réelles enregistrées</span
                >
              </div>

              <!-- Repère 3 : Votre prix souhaité au m² -->
              @if (ownerPricePerM2(); as ownerM2) {
                <div class="p-3 rounded-xl bg-white border border-neutral-3 flex flex-col">
                  <span class="text-[11px] font-semibold text-neutral-10">Votre prix souhaité</span>
                  <div class="flex items-baseline gap-1 mt-0.5">
                    <span class="text-base font-bold text-neutral-12"
                      >{{ ownerM2 | number: '1.0-0' : 'fr-FR' }} €</span
                    >
                    <span class="text-[11px] text-neutral-9 font-medium">/ m²</span>
                  </div>
                  <span class="text-[10px] text-neutral-9 mt-0.5">Prix initial de votre annonce</span>
                </div>
              }
            </div>

            <!-- Jauge DVF avec positionnement du prix de l'agent -->
            @if (agentPricePerM2(); as agentM2) {
              <div class="bg-white rounded-xl border border-neutral-3 p-3">
                <etxe-property-dvf-gauge
                  [currentPriceM2]="agentM2"
                  [medianPriceM2]="dvf.medianPriceM2"
                  [minPriceM2]="dvf.minPriceM2"
                  [maxPriceM2]="dvf.maxPriceM2"
                  [salesCount]="dvf.salesCount"
                  [propertyType]="dvf.propertyType"
                />
              </div>
            }
          </div>
        }
      }
    </div>
  } @else {
    <!-- RAPPEL MARCHÉ DVF LORSQUE L'AGENT N'A PAS ENCORE VISITÉ -->
    @if (dvfData(); as dvf) {
      @if (dvf.medianPriceM2) {
        <div
          class="p-4 rounded-2xl bg-neutral-2/60 border border-neutral-3 flex items-center justify-between gap-4 flex-wrap"
        >
          <div class="flex items-center gap-3">
            <div
              class="flex size-9 items-center justify-center rounded-xl bg-indigo-2 text-indigo-11 border border-indigo-3 shrink-0"
            >
              <mat-icon class="size-5 !text-lg">analytics</mat-icon>
            </div>
            <div class="flex flex-col">
              <span class="text-xs font-bold text-neutral-12">Repère de marché DVF du quartier</span>
              <span class="text-xs text-neutral-10">
                Médiane des ventes réelles DGFiP :
                <strong class="text-neutral-12"
                  >{{ dvf.medianPriceM2 | number: '1.0-0' : 'fr-FR' }} €/m²</strong
                >
                @if (ownerPricePerM2(); as ownerM2) {
                  (votre prix souhaité : {{ ownerM2 | number: '1.0-0' : 'fr-FR' }} €/m²)
                }
              </span>
            </div>
          </div>
          <span
            class="text-[11px] text-indigo-11 font-medium bg-indigo-2 px-2.5 py-1 rounded-md border border-indigo-4"
          >
            Avis de valeur attendu après visite
          </span>
        </div>
      }
    }
  }

  <!-- 2. ANALYSE QUALITATIVE DU BIEN (OBSERVATIONS & ATOUTS DE L'AGENT) -->
  @if (valuation(); as val) {
    @if (
      val.generalPresentation ||
      (val.strengths && val.strengths.length > 0) ||
      (val.weaknesses && val.weaknesses.length > 0)
    ) {
      <div class="p-4 sm:p-5 rounded-2xl bg-neutral-2 border border-neutral-3 flex flex-col gap-3.5">
        <div class="flex items-center gap-2">
          <mat-icon class="!text-sm size-4 text-neutral-11">notes</mat-icon>
          <span class="text-xs font-bold text-neutral-12 uppercase tracking-wide">
            Observations et analyse du bien
          </span>
        </div>

        @if (val.generalPresentation) {
          <p class="text-xs text-neutral-11 leading-relaxed m-0 whitespace-pre-line">
            {{ val.generalPresentation }}
          </p>
        }

        @if ((val.strengths && val.strengths.length > 0) || (val.weaknesses && val.weaknesses.length > 0)) {
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3 pt-1 border-t border-neutral-3/60">
            @if (val.strengths && val.strengths.length > 0) {
              <div class="flex flex-col gap-1.5">
                <span class="text-[11px] font-bold text-jade-11 flex items-center gap-1">
                  <mat-icon class="!text-xs size-3 text-jade-10">thumb_up</mat-icon>
                  <span>Atouts majeurs</span>
                </span>
                <div class="flex flex-wrap gap-1">
                  @for (str of val.strengths; track str) {
                    <span
                      class="px-2 py-0.5 rounded text-[11px] font-medium bg-jade-2 text-jade-12 border border-jade-4"
                    >
                      {{ str }}
                    </span>
                  }
                </div>
              </div>
            }

            @if (val.weaknesses && val.weaknesses.length > 0) {
              <div class="flex flex-col gap-1.5">
                <span class="text-[11px] font-bold text-amber-11 flex items-center gap-1">
                  <mat-icon class="!text-xs size-3 text-amber-10">warning</mat-icon>
                  <span>Points de vigilance</span>
                </span>
                <div class="flex flex-wrap gap-1">
                  @for (vig of val.weaknesses; track vig) {
                    <span
                      class="px-2 py-0.5 rounded text-[11px] font-medium bg-amber-2 text-amber-12 border border-amber-4"
                    >
                      {{ vig }}
                    </span>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  }

  <!-- 3. COMPARATIF D'ÉVOLUTION DES HONORAIRES (SI OFFRE FINALE SOUMISE) -->
  @if (hasFinalOffer()) {
    <div class="rounded-2xl border border-neutral-3 bg-neutral-2/50 p-4 sm:p-5 flex flex-col gap-3">
      <div class="flex items-center justify-between flex-wrap gap-2">
        <div class="flex items-center gap-2">
          <mat-icon class="!text-sm size-4 text-indigo-11">compare_arrows</mat-icon>
          <span class="text-xs font-bold text-neutral-12 uppercase tracking-wide">
            Évolution des honoraires
          </span>
        </div>
        @if (commissionRateDelta(); as delta) {
          @if (delta < 0) {
            <span
              class="px-2.5 py-0.5 rounded-full text-xs font-bold bg-jade-3 text-jade-11 border border-jade-6 flex items-center gap-1"
            >
              <mat-icon class="!text-xs size-3">trending_down</mat-icon>
              <span>Baisse de {{ -delta }} point par rapport à la candidature</span>
            </span>
          } @else if (delta > 0) {
            <span
              class="px-2.5 py-0.5 rounded-full text-xs font-bold bg-amber-3 text-amber-11 border border-amber-6 flex items-center gap-1"
            >
              <mat-icon class="!text-xs size-3">trending_up</mat-icon>
              <span>Ajustement de +{{ delta }} point par rapport à la candidature</span>
            </span>
          } @else {
            <span
              class="px-2.5 py-0.5 rounded-full text-xs font-bold bg-neutral-3 text-neutral-11 border border-neutral-6 flex items-center gap-1"
            >
              <mat-icon class="!text-xs size-3">check</mat-icon>
              <span>Taux confirmé à l'identique</span>
            </span>
          }
        }
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs">
        <div class="p-3.5 rounded-xl bg-white dark:bg-neutral-2 border border-neutral-3 flex flex-col gap-1">
          <span class="text-[11px] font-semibold text-neutral-10">Candidature initiale</span>
          <div class="flex items-baseline gap-2 mt-0.5">
            <span class="text-lg font-bold text-neutral-12">{{ initialCommissionRate() }} %</span>
            <span class="text-[11px] text-neutral-10">(honoraires indicatifs de départ)</span>
          </div>
        </div>

        <div class="p-3.5 rounded-xl bg-white dark:bg-neutral-2 border border-indigo-4 flex flex-col gap-1">
          <span class="text-[11px] font-bold text-indigo-11">Offre finale soumise</span>
          <div class="flex items-baseline gap-2 mt-0.5">
            <span class="text-lg font-extrabold text-indigo-12">{{ finalCommissionRate() }} %</span>
            <span class="text-[11px] text-indigo-10">
              @if (services().length > 0) {
                ({{ services().length }} prestation(s) incluse(s))
              } @else {
                (taux définitif retenu)
              }
            </span>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- 4. GRILLE FINANCIÈRE PROJETÉE -->
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-3.5">
    <!-- Proposed Commission Rate -->
    <div class="p-4 rounded-2xl bg-neutral-2 border border-neutral-3 flex flex-col justify-between">
      <div class="flex items-center justify-between gap-1">
        <span class="text-xs font-semibold text-neutral-10">
          {{ hasFinalOffer() ? 'Honoraires offre finale' : "Taux d'honoraires proposé" }}
        </span>
        @if (hasFinalOffer()) {
          <span class="text-[10px] font-bold px-2 py-0.5 rounded bg-indigo-3 text-indigo-11">
            Définitif
          </span>
        }
      </div>
      <div class="mt-2 flex items-baseline gap-1.5">
        <span class="text-2xl font-extrabold text-indigo-11">
          @if (proposedCommissionRate(); as rate) {
            {{ rate }} %
          } @else {
            Non spécifié
          }
        </span>
        @if (targetCommissionRate(); as target) {
          <span class="text-[11px] text-neutral-10" matTooltip="Taux recherché par le vendeur">
            (cible : {{ target }} %)
          </span>
        }
      </div>
      <span class="text-[11px] text-neutral-10 mt-1">
        @if (hasFinalOffer() && initialCommissionRate(); as init) {
          Candidature initiale à {{ init }} %
        } @else {
          Sur le prix net vendeur
        }
      </span>
    </div>

    <!-- Estimated Commission Euros -->
    <div class="p-4 rounded-2xl bg-neutral-2 border border-neutral-3 flex flex-col justify-between">
      <span class="text-xs font-semibold text-neutral-10">Honoraires estimés TTC</span>
      <div class="mt-2">
        <span class="text-2xl font-extrabold text-neutral-12">
          @if (estimatedCommissionEuros(); as comm) {
            {{ comm | number: '1.0-0' : 'fr-FR' }} €
          } @else {
            —
          }
        </span>
      </div>
      <span class="text-[11px] text-neutral-10 mt-1">
        {{ hasValuationPrices() ? 'Calculés sur le prix conseillé' : 'Calculés sur le prix vendeur' }}
      </span>
    </div>

    <!-- Projected Total FAI Price -->
    <div class="p-4 rounded-2xl bg-neutral-2 border border-neutral-3 flex flex-col justify-between">
      <span class="text-xs font-semibold text-neutral-10">Prix total FAI projeté</span>
      <div class="mt-2">
        <span class="text-2xl font-extrabold text-neutral-12">
          @if (totalFaiEuros(); as fai) {
            {{ fai | number: '1.0-0' : 'fr-FR' }} €
          } @else {
            —
          }
        </span>
      </div>
      <span class="text-[11px] text-neutral-10 mt-1">Prix affiché acquéreurs</span>
    </div>
  </div>

  <!-- 5. PRESTATIONS ET VALORISATION INCLUSES (OFFRE FINALE) -->
  @if (services().length > 0) {
    <div class="flex flex-col gap-3 pt-2">
      <div class="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-neutral-11">
        <mat-icon class="!text-sm size-4 text-indigo-9">verified</mat-icon>
        <span>Prestations et valorisation incluses ({{ services().length }})</span>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        @for (srv of services(); track srv) {
          <div
            class="p-3.5 rounded-2xl bg-neutral-2 border border-neutral-3 flex items-start gap-3 hover:border-indigo-4/60 transition-colors"
          >
            <div
              class="flex size-8 shrink-0 items-center justify-center rounded-xl bg-white dark:bg-neutral-1 border border-neutral-3 text-indigo-11"
            >
              <mat-icon class="size-4 !text-base">{{ getServiceIcon(srv) }}</mat-icon>
            </div>
            <div class="flex-1">
              <div class="text-xs font-bold text-neutral-12">
                {{ getServiceLabel(srv) }}
              </div>
              <div class="text-[11px] text-neutral-10 mt-0.5 leading-snug">
                {{ getServiceDescription(srv) }}
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  } @else if (!hasFinalOffer()) {
    <!-- NOTE EXPLICATIVE LORS DE LA CANDIDATURE -->
    <div
      class="p-4 rounded-2xl bg-neutral-2/60 border border-neutral-3 flex items-start gap-3.5 text-xs text-neutral-11"
    >
      <div
        class="flex size-8 shrink-0 items-center justify-center rounded-xl bg-indigo-2 text-indigo-11 border border-indigo-3"
      >
        <mat-icon class="size-4 !text-base">design_services</mat-icon>
      </div>
      <div>
        <div class="text-xs font-bold text-neutral-12">Stratégie de valorisation et prestations</div>
        <p class="text-[11px] text-neutral-10 mt-0.5 leading-relaxed m-0">
          Les prestations d'accompagnement (visite virtuelle, photographies professionnelles, home staging...)
          seront personnalisées et formalisées par l'agent lors de son offre finale après la visite du bien.
        </p>
      </div>
    </div>
  }

  <!-- METADATA FOOTER -->
  <div
    class="flex flex-wrap items-center justify-between gap-3 pt-3 border-t border-neutral-3 text-xs text-neutral-10"
  >
    <div class="flex items-center gap-1.5">
      <mat-icon class="!text-sm size-4 text-neutral-9">token</mat-icon>
      <span>
        Crédits engagés :
        <strong class="text-neutral-12">{{ application().creditsConsumed ?? 1 }} crédit</strong>
      </span>
    </div>

    @if (application().updatedAt; as upd) {
      <div class="flex items-center gap-1.5">
        <mat-icon class="!text-sm size-4 text-neutral-9">update</mat-icon>
        <span>Dernière mise à jour {{ upd | luxonDate: 'humanize' }}</span>
      </div>
    }
  </div>
</div>
